import _refiner from 'refiner-js';

class Analytics {
	static track(event) {
		// Track in Segment
		if (window.analytics) {
			window.analytics.track(event.eventName, event.properties);
		}

		// Track in Refiner
		_refiner('trackEvent', event.eventName);
	}

	static page(pageName, properties) {
		// Track page view in Segment
		if (window.analytics) {
			window.analytics.page(pageName, properties);
		}

		// Track page view in Refiner
		_refiner('trackEvent', `page_view_${pageName}`);
	}

	static identify(userId, traits) {
		// Identify user in Segment
		if (window.analytics) {
			window.analytics.identify(userId, traits);
		}

		// Identify user in Refiner
		_refiner('identifyUser', {
			id: userId,
			...traits,
		});
	}

	static group(groupId, traits) {
		// Group in Segment
		if (window.analytics) {
			window.analytics.group(groupId, traits);
		}
	}
}

// Export the class directly
export default Analytics;
